// client/src/pages/actions/ActionsList.js
import React from "react";
import SmartDataTable from "../../components/SmartDataTable";
import { useParams, useNavigate } from "react-router-dom";

export default function ActionsList() {
  const { datasetId } = useParams();
  const navigate = useNavigate();

  const columns = [
    { value: "name",        label: "Name",        search: "name" },
    { value: "type",        label: "Type",        search: "type" },
    { value: "landingName", label: "Landing Page", search: "landingName" },
    { value: "cardName",    label: "Card Design",  search: "cardName" },
    { value: "isActive",    label: "Active" },
    { value: "updatedAt",   label: "Updated" },
  ];

  const config = {
    columns,
    queryName: "/actions/listByDataSet",
    pathParams: { datasetId },          // used in server to filter
    fixedFilters: { datasetId },
    onAddNew: `/actions/add?datasetId=${datasetId}`,
    buttons: [
      { label: "Edit",   color: "green", action: "/actions/edit/{_id}" },
      { label: "Copy", color: "blue", requestPath: "/actions/copy/{_id}" },
      { label: "Delete", color: "red",   action: "delete" },
    ],
    deletePathTemplate: "/actions/delete/{_id}",
    deleteMethod: "DELETE",
  };

  return (
    <div className="page">
      <div className="page-header">
        <button className="back-link" onClick={() => navigate(-1)}>&larr; Back</button>
        <h2>Manage Actions</h2>
      </div>
      <div className="page-card">
        <SmartDataTable config={config} />
      </div>
    </div>
  );
}
